import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

interface SaveScenarioParams {
  salaryAnalysisId?: string;
  offerAmount: number;
  offerDetails?: any;
  counterOffer?: number;
  negotiationStrategy: string;
  talkingPoints?: string[];
  emailTemplates?: string[];
}

export function useSaveNegotiationScenario() {
  const { toast } = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: SaveScenarioParams) => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error("Not authenticated");

      const { data, error } = await supabase
        .from("negotiation_scenarios")
        .insert({
          user_id: user.id,
          salary_analysis_id: params.salaryAnalysisId,
          offer_amount: params.offerAmount,
          offer_details: params.offerDetails || {},
          counter_offer: params.counterOffer,
          negotiation_strategy: params.negotiationStrategy,
          talking_points: params.talkingPoints || [],
          email_templates: params.emailTemplates || [],
        })
        .select()
        .single();

      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["negotiation-scenarios"] });
      toast({
        title: "Scenario Saved",
        description: "Your negotiation scenario has been saved to history",
      });
    },
    onError: (error: any) => {
      toast({
        title: "Save Failed",
        description: error.message,
        variant: "destructive",
      });
    },
  });
}
